import React from 'react';

function NoData() {
    return (
        <p className="text-sm text-secondary">huh, nothing here</p>
    )
}

export default NoData;
